<template>
  <div class="quadro-zebra-container">
    <Cabecalho
      beneficio
      :tipo="'ncm'"
      :titulo="'NCM (Convênio ICMS 142/2018)'"
      :aliquota="dados.ncm_convenio"
    />
    <Cabecalho
      beneficio
      :tipo="'ncm'"
      :titulo="'Descrição (Convênio ICMS 142/2018)'"
      :aliquota="dados.descricao_convenio"
    />
    <Cabecalho
      v-if="dados.sigla_uf"
      beneficio
      :tipo="'ncm'"
      :titulo="'NCM (' + dados.sigla_uf + ')'"
      :aliquota="dados.ncm_uf"
    />
    <Cabecalho
      v-if="dados.sigla_uf"
      beneficio
      :tipo="'ncm'"
      :titulo="'Descrição (' + dados.sigla_uf + ')'"
      :aliquota="dados.descricao_uf"
    />
    <Cabecalho
      v-if="dados.base_calculo_difal"
      beneficio
      :tipo="'ncm'"
      :titulo="'Base de Cálculo DIFAL'"
      :aliquota="dados.base_calculo_difal"
    />
    <Cabecalho
      v-if="dados.base_legal_difal"
      beneficio
      :tipo="'link'"
      :titulo="'Base Legal “Base de Cálculo”'"
      :aliquota="dados.base_legal_difal"
    />
    <Cabecalho
      v-if="dados.guia_recolhimento_difal"
      guia
      :tipo="'guia'"
      :titulo="'Guia de Recolhimento'"
      :aliquota="dados.guia_recolhimento_difal"
      :linkGnre="dados.link_gnre"
    />
    <Cabecalho
      v-if="dados.label_pgdas"
      beneficio
      :tipo="'ncm'"
      :titulo="dados.label_pgdas"
      :aliquota="dados.valor_pgdas"
    />
  </div>
</template>

<script>
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
export default {
  name: "QuadroZebra",

  props: {
    dados: Object | Array
  },

  components: {
    Cabecalho
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.quadro-zebra-container {
  .cabecalho-container {
    &:nth-child(odd) {
      background: #e0e0e0;
    }

    &:nth-child(even) {
      background: #ececec;
    }

    &:not(:last-child) {
      border-bottom: 1px solid #ccc;
    }
  }
}
@media only print {
  .quadro-zebra-container {
    border: 1px solid #ccc !important;
  }
}
</style>
